module.exports = __webpack_public_path__ + "static/media/zllc2_en.3829808c.png";